import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6e35ba1d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "index"
};
const _hoisted_2 = {
  class: "innerWhiteBox"
};
const _hoisted_3 = {
  key: 0,
  class: "bottomBorderBox"
};
const _hoisted_4 = {
  class: "fieldBox"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "fieldTitle"
}, "下单数量", -1));
const _hoisted_6 = {
  class: "inputLineBox"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "10"
}, "10", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "20"
}, "20", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "50"
}, "50", -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "100"
}, "100", -1));
const _hoisted_11 = {
  key: 0,
  value: "200",
  disabled: ""
};
const _hoisted_12 = {
  key: 1,
  value: "400",
  disabled: ""
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "fieldTitle",
  style: {
    "margin-top": "20px"
  }
}, "做单轮次", -1));
const _hoisted_14 = {
  class: "bottomBorderBox"
};
const _hoisted_15 = {
  class: "fieldBox"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "fieldTitle"
}, "价格区间", -1));
const _hoisted_17 = {
  class: "inputLineBox"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 元 - ", -1));
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " 元 ", -1));
const _hoisted_20 = {
  class: "bottomBorderBox"
};
const _hoisted_21 = {
  class: "fieldBox"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "fieldTitle"
}, "收货地址", -1));
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "chooseLeft"
}, null, -1));
const _hoisted_24 = {
  class: "chooseRight"
};
const _hoisted_25 = {
  class: "chooseType"
};
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "10vh"
  }
}, null, -1));
const _hoisted_27 = {
  class: "btnLine",
  style: {
    "padding-bottom": "0"
  }
};
const _hoisted_28 = {
  class: "runningBox"
};
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "runningTitle"
}, "运单日志运行中", -1));
const _hoisted_30 = ["innerHTML"];
import CustomAddress from "./custom_address.vue";
import { ref, reactive, onMounted, onUnmounted, inject, nextTick } from "vue";
import { useRoute, useRouter } from "vue-router";
import { getGoods, orderTaskBuy, orderTaskSetting, orderTask } from "@/assets/js/api";
import { showFailToast, showSuccessToast, showToast } from "vant";

// 属性定义

export default {
  __name: 'buyInfo_pop',
  props: {
    taskName: String,
    type: [String, Number],
    platform: String,
    group_cycle: [Number, String]
  },
  emits: ["closexiadan"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;

    // 事件定义
    const emit = __emit;

    // 注入依赖
    const $back = inject("$back");

    // 路由
    const route = useRoute();
    const router = useRouter();

    // refs
    const tobottom = ref(null);
    const customAddressDialog = ref(null);

    // 响应式数据
    const themeVars = {
      radioDisabledLabelColor: "#5A5B5E",
      fieldDisabledTextColor: "#5A5B5E"
    };
    const task_name = ref(props.taskName);
    const buyType = ref(props.type);
    const showPopover = ref(false);
    const actions = ref([{
      text: "选项一"
    }, {
      text: "选项二"
    }, {
      text: "选项三"
    }]);
    const goodsInfo = ref([]);
    const goodsType = ref([]);
    const goodsMinTime = ref(0);
    const goodsMaxTime = ref(0);
    const shopMinTime = ref(0);
    const shopMaxTime = ref(0);
    const companyNum = ref(0);
    const companyMinTime = ref(0);
    const companyMaxTime = ref(0);
    const buyMoneyMin = ref(0);
    const buyMoneyMax = ref(0);
    const maxSellNum = ref(0);
    const orderType = ref(0);
    const collect = ref([]);
    const sku = ref(0);
    const platform = ref(props.platform);
    const addressList = ref([]);
    const customFieldName = {
      text: "address",
      value: "id"
    };
    const showAddress = ref(false);
    const reCheck = ref("");
    const buySuccess = ref(false);
    const buyResList = ref([]);
    const runningRes = ref([]);
    const resCont = ref([]);
    const istrue = ref(false);
    const alld = ref(0);
    const nowGood = ref("");
    const timeOut = ref("");
    const buyTimes = ref(1);
    const order_times = ref(10);
    const fortimes = ref(1);
    const stop_flag = ref(false);
    const current_click = ref(1);
    const orderList = ref([]);
    const checked = ref("");
    const timer = ref("");
    const group_cycle_1_limit = ref(0);
    const group_cycle_2_limit = ref(0);
    const group_cycle_4_limit = ref(0);
    const curr_1_cycle_num = ref(0);
    const curr_2_cycle_num = ref(0);
    const curr_4_cycle_num = ref(0);

    // 工具函数
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

    // 滚动到底部的工具函数
    const scrollToBottom = async () => {
      await nextTick();
      if (tobottom.value) {
        tobottom.value.scrollTop = tobottom.value.scrollHeight;
      }
    };

    // 打开自定义地址弹窗
    const showCustomAddressDialog = async () => {
      try {
        let res = await customAddressDialog.value.open();
        console.log("====>>res", res);
        const custom_address = res.address;
        const custom_name = res.receiver;
        const custom_phone = res.phone;
        if (!custom_address || !custom_name || !custom_phone) {
          throw new Error("请填写完整的地址信息");
        }
        reCheck.value = {
          ...reCheck.value,
          custom_address,
          custom_name,
          custom_phone
        };
      } catch (err) {
        closeRun();
        showFailToast("地址信息异常，结束运行");
        throw new Error("请填写完整的地址信息");
      }

      // console.log("====>>res", res);
    };

    // 选择收货地址
    const checkRecharge = ({
      selectedOptions
    }) => {
      reCheck.value = selectedOptions[0];
      showAddress.value = false;
    };

    // 加载数据
    const onload = async () => {
      const res = await orderTaskSetting({
        task_name: task_name.value
      });
      if (res.code === 200) {
        goodsInfo.value = res.data;
        goodsType.value.push(res.data.type);
        goodsMinTime.value = res.data.goods_mini;
        goodsMaxTime.value = res.data.goods_max;
        shopMinTime.value = res.data.shop_mini;
        shopMaxTime.value = res.data.shop_max;
        companyNum.value = res.data.compare_num;
        companyMinTime.value = res.data.compare_mini;
        companyMaxTime.value = res.data.compare_max;
        buyMoneyMin.value = res.data.mini_price;
        buyMoneyMax.value = res.data.max_price;
        maxSellNum.value = res.data.max_sell_num;
        orderType.value = res.data.order_type;
        collect.value.push(res.data.collect);
        sku.value = res.data.sku;
        addressList.value = res.data.address;
        group_cycle_1_limit.value = res.data.group_cycle_1_limit;
        group_cycle_2_limit.value = res.data.group_cycle_2_limit;
        group_cycle_4_limit.value = res.data.group_cycle_4_limit;
        curr_1_cycle_num.value = res.data.curr_1_cycle_num;
        curr_2_cycle_num.value = res.data.curr_2_cycle_num;
        curr_4_cycle_num.value = res.data.curr_4_cycle_num;
      }
      const orderRes = await orderTask({
        page: 1,
        pages_size: 10
      });
      if (orderRes.code === 200) {
        if (orderRes.data.length !== 0) {
          checked.value = 0;
          orderList.value = orderRes.data;
        }
        orderList.value.forEach((element, index) => {
          if (task_name.value == element.text) {
            checked.value = index;
          }
        });
      }
    };

    // 购买按钮点击事件
    const buyRun = async t => {
      if (!task_name.value) {
        showFailToast("错误，请重新进入");
        return;
      } else if (!reCheck.value.address) {
        showFailToast("请先选择收货地址后再操作！");
        return;
      } else if (buyType.value == "undefined") {
        showFailToast("类型错误，请重新进入");
        return;
      }
      if (props.group_cycle == "1") {
        if (curr_1_cycle_num.value >= group_cycle_1_limit.value) {
          showFailToast("1轮已达到上限");
          return;
        }
      } else if (props.group_cycle == "2") {
        if (curr_2_cycle_num.value >= group_cycle_2_limit.value) {
          showFailToast("仓库建设中");
          return;
        }
      } else if (props.group_cycle == "4") {
        if (curr_4_cycle_num.value >= group_cycle_4_limit.value) {
          showFailToast("仓库建设中");
          return;
        }
      }
      if (stop_flag.value) return showFailToast("错误，请重试");
      buySuccess.value = true;
      stop_flag.value = true;
      runningRes.value = [];
      fortimes.value = 0;
      buyTimes.value = 1;
      current_click.value++;
      t = buyType.value == 1 ? order_times.value : t;
      runningFun(t, current_click.value);
    };

    // 执行购买
    const buyIt = async () => {
      let req_data = {
        task_name: task_name.value,
        address: reCheck.value.address,
        id: nowGood.value.id,
        auto: buyType.value,
        group_cycle: props.group_cycle
      };
      if (reCheck.value.address == "自定义地址") {
        req_data.custom_address = reCheck.value.custom_address;
        req_data.custom_name = reCheck.value.custom_name;
        req_data.custom_phone = reCheck.value.custom_phone;
      }
      let res = await orderTaskBuy(req_data);
      if (res.code === 200) {
        runningRes.value.push("支付成功，已购买" + nowGood.value.title);
        await scrollToBottom();
      } else {
        runningRes.value.push("支付失败");
        await scrollToBottom();
        showToast(res.message);
        stop_flag.value = false;
        buySuccess.value = false;
        await sleep(1500);
        // closeRun();
        throw res;
      }
    };

    // 获取商品
    const getGood = async () => {
      let i = 1;
      while (i <= 5) {
        try {
          let getGoodsRes = await getGoods({
            platform: platform.value
          });
          if (getGoodsRes.code === 200 && getGoodsRes.data !== null) {
            nowGood.value = getGoodsRes.data;
            i = 6;
          } else {
            if (getGoodsRes.message) {
              showFailToast(getGoodsRes.message);
            } else {
              showToast("出错了，未获取到商品，请重试");
            }
            runningRes.value.push("出错了，未获取到商品");
            await scrollToBottom();
            stop_flag.value = false;
            buySuccess.value = false;
            await sleep(1500);
            closeRun();
          }
        } catch (e) {
          i++;
          if (i == 6) {
            runningRes.value.push("获取商品失败，结束运行");
            await scrollToBottom();
            stop_flag.value = false;
            buySuccess.value = false;
            await sleep(1500);
            throw new Error("获取商品失败，结束运行");
          }
          runningRes.value.push("未获取到商品,更换线路");
          await scrollToBottom();
          await sleep(1000);
          runningRes.value.push("正在筛选商品中");
          await scrollToBottom();
        }
      }
    };

    // 运行单个订单流程
    const runfunc = async current_click_val => {
      if (!stop_flag.value) return;
      if (buyTimes.value > 1 && buyTimes.value % 2 == 1) {
        if (orderList.value.length > checked.value) {
          checked.value = checked.value + 1;
          task_name.value = orderList.value[checked.value].text;
        }
        runningRes.value.push("账号自动切换为：" + task_name.value);
      }
      const step = 500;
      runningRes.value.push("正在开始第" + buyTimes.value + "个订单，账号：" + task_name.value);
      buyTimes.value = buyTimes.value + 1;
      await scrollToBottom();
      for (let i = 1; i <= 9; i++) {
        if (!stop_flag.value || current_click_val < current_click.value) break;
        await sleep(step);
        switch (i) {
          case 1:
            runningRes.value.push("正在筛选商品中");
            await getGood();
            break;
          case 2:
            runningRes.value.push("正在浏览商品1秒");
            break;
          case 3:
            runningRes.value.push("正在货比3家");
            break;
          case 4:
            runningRes.value.push("正在收藏商品");
            break;
          case 5:
            if (nowGood.value && nowGood.value.title) {
              runningRes.value.push("选中" + nowGood.value.title);
            } else {
              runningRes.value.push("选中商品");
            }
            break;
          case 6:
            runningRes.value.push("正在下单");
            if (reCheck.value.address == "自定义地址") {
              await showCustomAddressDialog();
            }
            break;
          case 7:
            runningRes.value.push("生成订单中...");
            break;
          case 8:
            runningRes.value.push("正在检测支付通道是否通畅");
            break;
          case 9:
            runningRes.value.push("正在支付中");
            try {
              await buyIt();
            } catch (e) {
              throw new Error("下单失败");
            }
            break;
        }
        await scrollToBottom();
      }
    };

    // 运行多个订单
    const runningFun = async (times, current_click_val) => {
      const step = 500;
      try {
        while (stop_flag.value && fortimes.value < times) {
          await runfunc(current_click_val);
          fortimes.value++;
          await sleep(step * 4);
        }
        showToast("运单任务执行完成");
        timer.value = setTimeout(() => {
          router.push("/order");
        }, 1500);
      } catch (e) {
        console.log(e);
        closeRun();
      }
    };

    // 关闭运行弹窗
    const closeRun = () => {
      stop_flag.value = false;
      buySuccess.value = false;
      clearTimeout(timer.value);
      emit("closexiadan", "Data from child");
    };

    // 生命周期钩子 - 组件挂载
    onMounted(() => {
      onload();
    });

    // 生命周期钩子 - 组件卸载
    onUnmounted(() => {
      clearTimeout(timer.value);
    });
    return (_ctx, _cache) => {
      const _component_van_nav_bar = _resolveComponent("van-nav-bar");
      const _component_van_field = _resolveComponent("van-field");
      const _component_van_icon = _resolveComponent("van-icon");
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_config_provider = _resolveComponent("van-config-provider");
      const _component_van_popup = _resolveComponent("van-popup");
      const _component_van_picker = _resolveComponent("van-picker");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_van_config_provider, {
        "theme-vars": themeVars
      }, {
        default: _withCtx(() => [_createVNode(_component_van_nav_bar, {
          title: buyType.value == 1 ? '批量下单' : '运单下单',
          border: false,
          class: "whiteNavBox"
        }, null, 8, ["title"]), _createElementVNode("div", _hoisted_2, [buyType.value == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_withDirectives(_createElementVNode("select", {
          name: "",
          id: "",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => order_times.value = $event),
          style: {
            "flex": "1",
            "padding": "10px",
            "border-radius": "5px"
          }
        }, [_hoisted_7, _hoisted_8, _hoisted_9, _hoisted_10, __props.group_cycle > 1 ? (_openBlock(), _createElementBlock("option", _hoisted_11, " 200(仓库建设中) ")) : _createCommentVNode("", true), __props.group_cycle > 1 ? (_openBlock(), _createElementBlock("option", _hoisted_12, " 400(仓库建设中) ")) : _createCommentVNode("", true)], 512), [[_vModelSelect, order_times.value]])]), _hoisted_13])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("div", _hoisted_17, [_createVNode(_component_van_field, {
          class: "inputBox",
          modelValue: buyMoneyMin.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => buyMoneyMin.value = $event),
          placeholder: "0",
          "input-align": "center",
          disabled: ""
        }, null, 8, ["modelValue"]), _hoisted_18, _createVNode(_component_van_field, {
          class: "inputBox",
          modelValue: buyMoneyMax.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => buyMoneyMax.value = $event),
          placeholder: "0",
          "input-align": "center",
          disabled: ""
        }, null, 8, ["modelValue"]), _hoisted_19])])]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_hoisted_22, _createElementVNode("div", {
          class: "chooseBox",
          onClick: _cache[3] || (_cache[3] = $event => showAddress.value = true)
        }, [_hoisted_23, _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, _toDisplayString(reCheck.value ? reCheck.value.address : "请选择收货地址"), 1), _createVNode(_component_van_icon, {
          class: "chooseArrow",
          size: "16px",
          name: "play"
        })])])])]), _hoisted_26, _createElementVNode("div", _hoisted_27, [_createVNode(_component_van_button, {
          onClick: _cache[4] || (_cache[4] = $event => buyRun(2)),
          class: "nextBtn",
          type: "primary",
          block: "",
          style: {
            "margin": "0"
          }
        }, {
          default: _withCtx(() => [_createTextVNode(" 执行 ")]),
          _: 1
        })])])]),
        _: 1
      }), _createVNode(_component_van_popup, {
        closeable: "",
        show: buySuccess.value,
        "onUpdate:show": _cache[5] || (_cache[5] = $event => buySuccess.value = $event),
        "close-on-click-overlay": false,
        round: "",
        onClose: closeRun,
        style: {
          padding: '30px 15px',
          width: '80%',
          maxHeight: '100%'
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_28, [_hoisted_29, _createElementVNode("div", {
          class: "runningCont",
          ref_key: "tobottom",
          ref: tobottom
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(runningRes.value, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index,
            innerHTML: item
          }, null, 8, _hoisted_30);
        }), 128))], 512), _createVNode(_component_van_button, {
          onClick: closeRun,
          round: "",
          class: "nextBtn",
          type: "primary",
          block: ""
        }, {
          default: _withCtx(() => [_createTextVNode(" 取消 ")]),
          _: 1
        })])]),
        _: 1
      }, 8, ["show"])]), _createVNode(_component_van_popup, {
        show: showAddress.value,
        "onUpdate:show": _cache[7] || (_cache[7] = $event => showAddress.value = $event),
        round: "",
        position: "bottom",
        "close-on-click-overlay": false
      }, {
        default: _withCtx(() => [_createVNode(_component_van_picker, {
          title: '选择地址',
          "show-toolbar": "",
          columns: addressList.value,
          "columns-field-names": customFieldName,
          "confirm-button-text": '确认',
          "cancel-button-text": '取消',
          onConfirm: checkRecharge,
          onCancel: _cache[6] || (_cache[6] = $event => showAddress.value = false)
        }, null, 8, ["columns"])]),
        _: 1
      }, 8, ["show"]), _createVNode(CustomAddress, {
        ref_key: "customAddressDialog",
        ref: customAddressDialog
      }, null, 512)], 64);
    };
  }
};